import * as Booking from './Booking';
import * as Customer from './Customer';
import * as Internationalisation from './Internationalisation';
import * as Location from './Location';
import * as Payments from './Payments';
import * as Players from './Players';
import * as Sessions from './Sessions';
import * as Sites from './Sites';
import * as UI from './UI';
import * as Games from './Games';
import * as AppSettings from './AppSettingsState';
import * as PurchaseTypes from './PurchaseTypes';
import * as GiftVoucher from './GiftVoucher';
import * as Attribution from './Attribution';
import * as FeatureFlags from './featureFlags';
import * as MicroCopy from './MicroCopy';
import * as Currencies from './Currencies';
import * as PremiumPtv from './PremiumPtv';
import * as Invoice from './Invoice';
import * as PaymentOption from './PaymentOption';
import * as SplitPaymentLanding from './SplitPaymentLanding';
import * as SplitAllocate from './SplitAllocate';
import * as SplitJoin from './SplitJoin';
import * as BalancePaymentLanding from './BalancePaymentLanding';
import * as Rewards from './Rewards';

import type { Action } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';
import type { CallHistoryMethodAction } from 'connected-react-router';

export interface IApplicationState {
    attribution: Attribution.IAttributionState;
    players: Players.IPlayerState;
    sites: Sites.ISiteState;
    location: Location.ILocationState;
    session: Sessions.ISessionState;
    booking: Booking.IBookingState;
    customer: Customer.ICustomerState;
    intl: Internationalisation.IInternationalisationState;
    payments: Payments.IPaymentState;
    ui: UI.IUIState;
    games: Games.IGameState;
    appSettings: AppSettings.IAppSettingsState;
    purchaseType: PurchaseTypes.IPurchaseTypeState;
    giftVoucher: GiftVoucher.IGiftVoucherState;
    microCopy: MicroCopy.MicroCopyState;
    featureFlags: FeatureFlags.FeatureFlagState;
    currencies: Currencies.ICurrencyState;
    premiumPtv: PremiumPtv.IPremiumPtvState;
    invoice: Invoice.IInvoiceState;
    paymentOption: PaymentOption.IPaymentOptionState;
    splitPaymentLanding: SplitPaymentLanding.ISplitPaymentLandingState;
    splitAllocate: SplitAllocate.ISplitAllocateState;
    splitJoin: SplitJoin.ISplitJoinState;
    balancePaymentLanding: BalancePaymentLanding.IBalancePaymentLandingState;
    rewards: Rewards.IRewardsState;
}

export const reducers = {
    premiumPtv: PremiumPtv.reducer,
    attribution: Attribution.reducer,
    players: Players.reducer,
    sites: Sites.reducer,
    location: Location.reducer,
    session: Sessions.reducer,
    booking: Booking.reducer,
    customer: Customer.reducer,
    intl: Internationalisation.reducer,
    payments: Payments.reducer,
    ui: UI.reducer,
    games: Games.reducer,
    appSettings: AppSettings.reducer,
    purchaseType: PurchaseTypes.reducer,
    giftVoucher: GiftVoucher.reducer,
    microCopy: MicroCopy.reducer,
    featureFlags: FeatureFlags.featureFlagReducer,
    invoice: Invoice.reducer,
    currencies: Currencies.reducer,
    paymentOption: PaymentOption.reducer,
    splitPaymentLanding: SplitPaymentLanding.reducer,
    splitAllocate: SplitAllocate.reducer,
    splitJoin: SplitJoin.reducer,
    balancePaymentLanding: BalancePaymentLanding.reducer,
    rewards: Rewards.reducer,
};

export interface IAppThunkAction<TAction extends Action> {
    (dispatch: ThunkDispatch<IApplicationState, void, TAction | CallHistoryMethodAction>, getState: () => IApplicationState): void;
}

export interface IGoogleTagManagerEvent {
    // Normal Values
    category: string;
    action: string;
    label: string;
    value?: number;

    // Enhanced Values
    event: string;
    eventProps: object;
    // state?: object;
}

export interface IAnalyticsAction extends Action {
    googleTagManagerEvent?: Array<IGoogleTagManagerEvent> | IGoogleTagManagerEvent;
    brazeEvent?: any;
}
